import { ConfirmSolid } from '@icons';
import React, { ReactNode } from 'react';
import { Button, Modal } from 'react-bootstrap';

interface SuccessModalProps {
    message: ReactNode;
    show: boolean;
    onHide: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ message, show, onHide }) => {
    return <Modal
        show={show}
        onHide={() => {
            onHide();
        }}
        centered
        className="supermodal"
        backdropClassName="supermodal-backdrop"
    >
        <Modal.Header
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
            }}
        >
            <ConfirmSolid style={{ margin: '8px' }} />
            <h3
                style={{
                    fontSize: '24px',
                    textAlign: 'center',
                    lineHeight: '35px',
                    marginBottom: 0,
                    fontWeight: 700,
                }}
            >
                Perfetto!
            </h3>
        </Modal.Header>
        <Modal.Body
            style={{
                padding: '0 16px',
            }}
        >
            <p
                style={{
                    textAlign: 'center',
                    marginBottom: 0,
                    lineHeight: '28px',
                }}
            >
                {message}
            </p>
        </Modal.Body>
        <Modal.Footer>
            <Button
                className="btn custom-primary-button"
                style={{
                    width: '100%',
                    height: '48px',
                }}
                onClick={() => {
                    onHide();
                }}
            >
                Chiudi
            </Button>
        </Modal.Footer>
    </Modal>
}

export default SuccessModal